import {Directive} from '@angular/core';

@Directive({
  selector: '[cfFamilyProductSubheader]',
})
export class FamilyProductSubheaderDirective {

  constructor() {
  }

}
